module.exports = __webpack_public_path__ + "Infrastructure.dd6b677133193384f3da20626eacff82.hashedasset.svg";